export const firebaseConfig = {
  apiKey: "AIzaSyBnS40iXras0qYS1YTnYZQj6iRIANfBY9U",
  authDomain: "gastro-painguide.firebaseapp.com",
  projectId: "gastro-painguide",
  storageBucket: "gastro-painguide.firebasestorage.app",
  messagingSenderId: "498727607798",
  appId: "1:498727607798:web:705469a820e49f4459bbd7",
  measurementId: "G-J358MPTKER"
};
